export const playSound = (audioSource, audioRef, play, setPlay) => {
    if (!audioSource) {
        return;
    }
    // Stop and reset any currently playing audio
    if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
    }
    if (play) {
        // Create new audio and store it in the ref
        const sound = new Audio(audioSource);
        sound.play().catch((error) => {
            if (error.name !== 'AbortError') {
                console.error('Audio playback error:', error);
            }
        });
        // Optional: Reset play state when sound ends
        sound.onended = () => {
            if (setPlay)
                setPlay(false);
        };
    }
    // Cleanup function for useEffect (runs on unmount or before re-running effect)
    return () => {
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            audioRef.current = null;
        }
        if (setPlay)
            setPlay(false);
    };
};
